import { Link } from 'react-router-dom'
import { useAppTranslation } from '../../hook'
import { Helmet } from 'react-helmet-async'
import './terms.page.scss'

export const Terms = () => {
    const { t, i18n } = useAppTranslation()
    return (
        <main className="page page-terms">
            <Helmet>
                <title>OTP Multiasset - Terms </title>
                <meta name="description" content="OTP Multiasset - Terms" />
            </Helmet>
            <div className="main-div">
                <div className="content-card">
                    <div className="text-container">
                        <div className="content-simple-text">
                            <div>{t('terms_page_content_first_text')}</div>
                            <div>{t('terms_page_content_second_text')}</div>
                            <h2 className="title-text-h2 content-title">{t('terms_page_content_first_tile')}</h2>
                            <div>{t('terms_page_content_third_text')}</div>
                            <h2 className="title-text-h2 content-title">{t('terms_page_content_second_tile')}</h2>
                            <div>{t('terms_page_content_fourth_text')}</div>
                            <h2 className="title-text-h2 content-title">{t('terms_page_content_third_tile')}</h2>
                            <div>{t('terms_page_content_fifth_text')}</div>
                            <Link className="form-terms-label" target="_blank" rel="noopener noreferrer" to={i18n.language.includes('hu') ? 'https://www.otpalapkezelo.hu/hu/dokumentumok/szabalyzatok' : 'https://www.otpalapkezelo.hu/hu/dokumentumok/szabalyzatok'}>
                                <div className="form-terms-label" dangerouslySetInnerHTML={{ __html: t('terms_page_content_last_text') }} />
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}
